module.exports = __webpack_public_path__ + "img/hr-brown-carpet-grass-08.91ace930.png";